<template>
  <div v-show="dataReady" class="app">
    <template v-if="isNeedSuggestions">
      <Feedback/>
    </template>
    <div ref="main">
      <div
        v-if="!isLogin"
        class="login"
        :style="{ backgroundImage: `url(${info.BannerImg_Default})` }"
      >

        <div class="ruleToggle" @click="showRuelPop = true">
          活动规则<img src="./assets/icons/arrow-right.png" alt="" />
        </div>
        <div class="content">
          <button class="btn" @click="handleLogin">点击登录/注册</button>
        </div>
      </div>
      <div v-else-if="hasBuy || isOver" :class="['card', isOver && 'is-over']">
        <div class="ruleToggle" @click="showRuelPop = true">
          活动规则<img src="./assets/icons/arrow-rightw.png" alt="" />
        </div>

        <div
          class="card-content"
          :style="{
            backgroundImage: `url(${
              isOver ? info.BannerImg_ReBuy : info.BannerImg_Buyed
            })`
          }"
        >
          <img :src="info.TagImg" class="card-widget" />

          <div class="text1">{{ info.SaveDesc }}</div>
          <div class="card-status">
            <div class="card-statusItem yiling">
              <div class="text">已领取</div>
              <div class="num">{{ act.ReceivedCount }}件</div>
            </div>
            <div class="card-statusItem shengyu">
              <div class="text">剩余可领取</div>
              <div class="num">{{ act.CanReceivedCount }}件</div>
            </div>
          </div>

          <!-- <div class="text2">
          <img src="./assets/icons/money.png" alt="" />已为你节省$298元
        </div> -->
          <button v-if="isOver" class="btn" @click="selectPay">
            立即续费
          </button>
          <div
            v-if="act.ReceivedCount > 0"
            class="text-saved"
            @click="showReceivedPop = true"
          >
            <img src="./assets/icons/money.png" />已为你节省{{
              act.SavedMoney
            }}元<img src="./assets/icons/next.png" />
          </div>
        </div>
      </div>
      <div
        v-else
        class="buy"
        :style="{ backgroundImage: `url(${info.BannerImg_Buying})` }"
      >
        <div :class="isNeedSuggestions?'ruleToggle ruleToggle-1':'ruleToggle'" @click="showRuelPop = true">
          活动规则<img src="./assets/icons/arrow-right.png" alt="" />
        </div>
        <div class="content">
          <div  @click="selectPay" :class="isNeedSuggestions?'btn btn-1':'btn btn-2'">
            <div class="price">
              <span class="promptPrice"
                ><span class="priceSymbol">￥</span>{{ info.ActPrice }}</span
              ><span class="salePrice"
                ><span class="priceSymbol">￥</span>{{ info.Price }}</span
              >
            </div>
            <div class="text1">立即开通</div>
          </div>
        </div>
      </div>
    </div>

    <div class="goods">
      <div class="goods-title">你家的清洁用品<br />我们都包了</div>
      <div v-if="hasBuy" class="goods-titleSubText">
        （每笔订单限领走1件，运费自理）
      </div>
      <div class="goodsList">
        <template v-for="(group, index) in itemGroups">
          <div :key="index" class="goodsList-itemRow">
            <div
              v-for="(item, index) in group"
              :key="index"
              class="goodsList-item"
            >
              <GoodItem
                @click="gotoGoodDetail(item)"
                @action="
                  lingquItem = item;
                  showLingQuPop = true;
                "
                :data="item"
                :config="info"
                :disabled="!hasBuy"
              />
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="!hasBuy && !isOver" ref="footer" class="footer">
      <div class="footer-left">
        <div class="price">
          <span class="promptPrice"
            ><span class="priceSymbol">￥</span>{{ info.ActPrice }}</span
          ><span class="salePrice"
            ><span class="priceSymbol">￥</span>{{ info.Price }}</span
          >
        </div>
      </div>
      <div class="footer-right" @click="selectPay">
        <div class="text1">立即开通</div>
        <div class="text2">每件到手价仅4.08元</div>
      </div>
    </div>

    <DialogRule :visible.sync="showRuelPop">
      {{ rule }}
    </DialogRule>
    <Dialog class="lingquPop" :visible.sync="showLingQuPop" noOkBtn noCancelBtn>
      <TitleStyle slot="title">领取提醒</TitleStyle>
      <div class="text1">是否确认领取以下商品，<span>领取后不可更换</span></div>
      <div class="item">
        <img class="item_image" :src="lingquItem.Image" alt="" />
        <div class="item_detail">
          <div class="item_name">{{ lingquItem.Name }}</div>
          <div class="item_price">
            <span class="priceSymbol">￥</span>{{ lingquItem.SalePrice }}
          </div>
          <div class="text_info">有效期30天，每笔订单限领走1件超级福利卡商品</div>
        </div>
      </div>
      <button class="btn" @click="handleLingQuClick">确认领取</button>
<!--      <div class="textHint">-->
<!--        有效期30天<br/>每笔订单限领走1件超级福利卡商品-->
<!--      </div>-->
    </Dialog>
    <Dialog
      class="payResultPop"
      okBtnTxt="已完成付款"
      cancelBtnTxt="未完成付款"
      :visible.sync="showPayResultPop"
      @ok="
        showPayResultPop = false;
        doQueryPayResult();
      "
      @cancel="
        showPayResultPop = false;
        doQueryPayResult();
      "
    >
      <template v-slot:title>
        <CountDown class="text1" :time.sync="queryPayResultTime">
          <!-- prettier-ignore -->
          <template v-slot:default="time">正在请求支付结果{{ time.second[1] }}s</template>
        </CountDown>
        <div class="text2">如果你已完成付款，<br />请点击「已完成付款」</div>
      </template>
    </Dialog>
    <Dialog
      :class="['receviedPop', isOver && 'is-over']"
      noOkBtn
      noCancelBtn
      :visible.sync="showReceivedPop"
    >
      <div slot="title">
        已为你节省 <span>{{ act.SavedMoney }}</span> 元
      </div>
      <div class="listTitle">省钱明细</div>
      <div class="list">
        <div
          v-for="(item, index) in receivedItems"
          :key="index"
          class="listItem"
        >
          <ReceivedItem
            @click="gotoGoodDetail(item)"
            :data="item"
            :config="info"
            :disabled="!hasBuy"
          />
        </div>
      </div>

      <div class="btnContainer" v-if="isOver">
        <button
          class="btn"
          @click="
            showReceivedPop = false;
            selectPay();
          "
        >
          立即续费
        </button>
      </div>
    </Dialog>
    <Dialog class="payPop" noOkBtn noCancelBtn :visible.sync="showPayPop">
      <TitleStyle slot="title">请选择支付方式</TitleStyle>

      <div class="payItem" @click="payMethod = 'alipay'">
        <img class="icon" src="./assets/icons/ali.png" alt="" />
        <span class="text">支付宝</span>
        <input
          type="radio"
          id="checkbox1"
          name="paymethod"
          value="alipay"
          v-model="payMethod"
        />
        <label class="radio" for="checkbox1"></label>
      </div>
      <div class="payItem" @click="payMethod = 'wechat'">
        <img class="icon" src="./assets/icons/wechat.png" alt="" />
        <span class="text">微信</span>
        <input
          type="radio"
          id="checkbox2"
          name="paymethod"
          value="wechat"
          v-model="payMethod"
        />
        <label class="radio" for="checkbox2"></label>
      </div>

      <div class="bottom">
        <div class="price">
          <span class="promptPrice"
            ><span class="priceSymbol">￥</span>{{ info.ActPrice }}</span
          ><span class="salePrice"
            ><span class="priceSymbol">￥</span>{{ info.Price }}</span
          >
        </div>
        <button class="btn" @click="handleBuyClick">去支付</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import dev from "helper/dev";
import { isApp } from "helper/env";
import fectx from "helper/fectx";
import fectxAlt from "helper/fectxAlt";
import { retry } from "helper/retry";
import { partition } from "utils";
import service from "./service";
import { urlQuery } from "utils/url";
import Message from "base-components/Message";
import CountDown from "components/CountDown";
import GoodItem from "./components/Item";
import ReceivedItem from "./components/ReceivedItem";
import TitleStyle from "./components/TitleStyle/TitleStyle";
import DialogRule from "./shared/components/DialogRule";
import Dialog from "./shared/components/Dialog";
import Feedback from "./shared/components/feedback/Feedback";
// import BlockGroupShelf from "./components/BlockGroupShelf";


const mockGood = () => {
  return {
    PromotionId: 1064,
    GoodsId: 35839,
    IsSoldOut: false,
    GoodsName: "旋盖式不锈钢随手保温杯",
    GoodsImg:
      "https://i1.lifevccdn.com//upload/AppItemHeaders/d9903895c8624d15ab0f96f6a10824a8.jpg",
    GoodsSpec: "蓝色,380ml",
    Price: 99,
    IsCanReceive: true
  };
};

export default {
  name: "App",
  components: {
    Dialog,
    DialogRule,
    GoodItem,
    TitleStyle,
    CountDown,
    ReceivedItem,
    Feedback
  },
  data() {
    return {
      dataReady: false,
      webid: dev("35DD8C328D70445E83F216B79EF5E258", urlQuery.webid),

      rule: "",
      items: [],
      receivedItems: [],
      info: {
        // BannerImg_Default, 登录按钮
        // BannerImg_Buying, 购买按钮
        // BannerImg_Buyed, 已购买
        // BannerImg_ReBuy, 续费按钮
        // ActPrice: 49,
        // BannerImg:
        //   "http://i1.lifevccdn.com//Upload/AppCategoryBanner/0832aee200a74fbabfea2534123ee28d.png",
        // BeforeButtonDesc: "免费领取",
        // Price: 99,
        // ReceiveNum: 12,
        // RuleString: "规则如下：,1111",
        // SaveDesc: "总计可领取12件明星清洁品",
        // SuccessPromptDesc: "领取成功，礼品券已放在你的账户",
        // TagImg:
        //   "http://i1.lifevccdn.com//Upload/AppCategoryBanner/424f5b6cafc24c0fbd8fab2a15599179.png"
      },
      act: {
        ReceivedCount: null,
        CanReceivedCount: null,
        OrderCode: null,
        OrderId: null,
        NeedReBuy: false,
        NeedLogin: false,
        SavedMoney: 0
      },

      payMethod: "wechat",
      isLogin: false,

      lingquItem: {},

      queryPayResultTime: 5000,
      showRuelPop: false,
      showPayPop: false,
      showPayResultPop: false,
      showLingQuPop: false,
      showReceivedPop: false,
      isNeedSuggestions:false
    };
  },
  async created() {
    if (service.isLogin()) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }

    if (service.toBoolean(service.getUrlKey('isNeedSuggestions'))){
      this.isNeedSuggestions = true;
    }else {
      this.isNeedSuggestions = false;
    }

    this.getData();
  },
  computed: {
    hasBuy() {
      return this.act.OrderCode && this.act.OrderCode !== "";
    },
    isOver() {
      return this.act.NeedReBuy;
    },
    itemGroups() {
      return partition(this.items, 3);
    }
  },
  watch: {
    queryPayResultTime(value) {
      if (value > 0) {
        this.doQueryPayResult();
      }
    },
    showPayResultPop(v) {
      if (v === false) {
        setTimeout(() => {
          this.queryPayResultTime = 5000;
        }, 0);
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    handleScroll() {
      const $main = this.$refs.main;
      const $footer = this.$refs.footer;
      if (!$main || !$footer) {
        return;
      }

      const { bottom } = $main.getBoundingClientRect();
      if (bottom <= 0 && !$footer.classList.contains("is-active")) {
        $footer.classList.add("is-active");
      } else if (bottom > 0 && $footer.classList.contains("is-active")) {
        $footer.classList.remove("is-active");
        return;
      }
    },
    handleLogin() {
      service.login(() => {
        this.getData();
        this.isLogin = true;
      });
    },
    gotoGoodDetail(good) {
      service.gotoUrl(`inner:///item/${good.GoodsId}`);
    },
    async handleLingQuClick() {
      this.showLingQuPop = false;

      if (this._pendingLingqu) {
        return;
      }

      try {
        this._pendingLingqu = true;
        await this.doLingqu(this.lingquItem);
      } finally {
        this._pendingLingqu = false;
      }
    },
    async doLingqu(item) {
      let resp;
      try {
        resp = await fectx.post(
          `/MarketingAct/${this.webid}/OneYear/${this.act.OrderCode}/Receive?pid=${item.PromotionId}`
        );
      } catch (error) {
        Message.error("网络错误");
        return;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        return;
      }

      const payload = data.InnerData;
      if (payload.Error) {
        this.handleRespError(payload.Error);
      } else {
        Message.success("领取成功");
        // item.IsCanReceive = false;
        // this.$set(this.act, "ReceivedCount", this.act.ReceivedCount + 1);
        // this.$set(this.act, "CanReceivedCount", this.act.CanReceivedCount - 1);
        this.getData();
        setTimeout(() => {
          service.gotoUrl("usercenter/giftcoupon");
        }, 230);
      }
    },
    handleRespError(error) {
      // alert(error.Msg)

      if (error.Code === "GoPage") {
        service.gotoUrl(error.Data);
      } else if (error.Code === "AlertMsg") {
        Message.hide()
        setTimeout(() => {
          Message.error(error.Msg);
        }, 230);
      }
    },
    async getInfo() {
      let resp;
      try {
        resp = await fectx.get(`/MarketingAct/${this.webid}/OneYear/Info`);
      } catch (error) {
        Message.error("网络错误");
        return;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        return;
      }

      this.dataReady = true;
      const payload = data.InnerData;
      // const payload = {
      //   Info: {
      //     ActPrice: 49,
      //     BannerImg_Buyed:
      //       "http://i1.lifevccdn.com//Upload/AppCategoryBanner/d7e84100294d4821aa89e423e71d675d.png",
      //     BannerImg_Buying:
      //       "http://i1.lifevccdn.com//Upload/AppCategoryBanner/c2cee80bda58405fad85050d6f5cad80.png",
      //     BannerImg_Default:
      //       "http://i1.lifevccdn.com//Upload/AppCategoryBanner/8c3d2e7f52e4422e95ce4d1b4dbfbabb.png",
      //     BannerImg_ReBuy:
      //       "http://i1.lifevccdn.com//Upload/AppCategoryBanner/36a2096383af432b8bc9f8077e3c3178.png",
      //     BeforeButtonDesc: "免费领取",
      //     Price: 99,
      //     ReceiveNum: 12,
      //     RuleString: "1、超级福利卡一经开通，不支持取消/退款，敬请谅解。",
      //     SaveDesc: "总计可领取12件明星清洁品",
      //     SuccessPromptDesc: "领取成功，礼品券已放在你的账户",
      //     TagImg:
      //       "http://i1.lifevccdn.com//Upload/AppCategoryBanner/2a9ea665a2254fe7a246024051149ab3.png",
      //     Title: "明星清洁品，超级福利卡"
      //   },
      //   Items: [mockGood(), mockGood(), mockGood(), mockGood()],
      //   UserInfo: {
      //     CanReceivedCount: 0,
      //     NeedLogin: false,
      //     NeedReBuy: false,
      //     OrderCode: "xxx",
      //     OrderId: "7878",
      //     ReceivedCount: 4,
      //     SavedMoney: 0
      //   }
      // };
      this.info = payload.Info;
      this.rule = payload.Info.RuleString;
      this.items = payload.Items.map(item => ({
        ...item,
        Name: item.GoodsName,
        Image: item.GoodsImg,
        SalePrice: item.Price
      }));
      if (payload.UserInfo) {
        this.act = payload.UserInfo;
      }

      if (this.act.OrderId) {
        this.getExtraInfo(this.act.OrderId);
      }
      // this.$service.setTitle(payload.Banner.ActName);
    },
    async getExtraInfo(orderId) {
      let resp;
      try {
        resp = await fectx.post(
          `/MarketingAct/${this.webid}/OneYear/${orderId}/ReceiveInfo`
        );
      } catch (error) {
        Message.error("网络错误");
        return;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        return;
      }
      const payload = data.InnerData;
      // const payload = {
      //   ReceiveInfoList: [
      //     {
      //       Id: 48375,
      //       PromotionId: 1157,
      //       GoodsId: 32796,
      //       GoodsName: "马桶去污除菌除臭剂(省心型)",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/5d5f13d6fa1945b4b4327574d5d14e59.png",
      //       ReceivedTime: "2019-12-26 09:53:57.813",
      //       SavedMoney: 29
      //     },
      //     {
      //       Id: 48376,
      //       PromotionId: 1163,
      //       GoodsId: 35095,
      //       GoodsName: "新疆阿瓦提加厚吸水毛巾",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/3986c2b130b04f6794b286cd78a11b70.png",
      //       ReceivedTime: "2019-12-26 09:54:42.090",
      //       SavedMoney: 29
      //     },
      //     {
      //       Id: 48375,
      //       PromotionId: 1157,
      //       GoodsId: 32796,
      //       GoodsName: "马桶去污除菌除臭剂(省心型)",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/5d5f13d6fa1945b4b4327574d5d14e59.png",
      //       ReceivedTime: "2019-12-26 09:53:57.813",
      //       SavedMoney: 29
      //     },
      //     {
      //       Id: 48376,
      //       PromotionId: 1163,
      //       GoodsId: 35095,
      //       GoodsName: "新疆阿瓦提加厚吸水毛巾",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/3986c2b130b04f6794b286cd78a11b70.png",
      //       ReceivedTime: "2019-12-26 09:54:42.090",
      //       SavedMoney: 29
      //     },
      //     {
      //       Id: 48375,
      //       PromotionId: 1157,
      //       GoodsId: 32796,
      //       GoodsName: "马桶去污除菌除臭剂(省心型)",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/5d5f13d6fa1945b4b4327574d5d14e59.png",
      //       ReceivedTime: "2019-12-26 09:53:57.813",
      //       SavedMoney: 29
      //     },
      //     {
      //       Id: 48376,
      //       PromotionId: 1163,
      //       GoodsId: 35095,
      //       GoodsName: "新疆阿瓦提加厚吸水毛巾",
      //       GoodsImg:
      //         "http://i1.lifevccdn.com//Upload/AppCategoryBanner/3986c2b130b04f6794b286cd78a11b70.png",
      //       ReceivedTime: "2019-12-26 09:54:42.090",
      //       SavedMoney: 29
      //     }
      //   ]
      // };
      this.receivedItems = payload.ReceiveInfoList.map(item => ({
        ...item,
        Name: item.GoodsName,
        Image: item.GoodsImg,
        SalePrice: item.Price
      }));
    },
    selectPay() {
      if (!service.isLogin()) {
        this.handleLogin();
        return;
      }

      this.showPayPop = true;
    },
    async handleBuyClick() {
      this.showPayPop = false;

      if (!service.isLogin()) {
        this.handleLogin();
        return;
      }

      if (this._pendingPay) {
        return;
      }

      try {
        Message.success("请求支付中", {
          timeout: 0
        });
        this._pendingPay = true;
        await this.doBuy();
        Message.hide();
      } finally {
        this._pendingPay = false;
      }
    },
    async doBuy() {
      let resp;
      try {
        resp = await fectx.post(
          `/MarketingAct/${this.webid}/OneYear/OrderGoPay?paycode=${
            this.payMethod === "alipay" ? "alipay_app" : "wxpay_app"
          }`
        );
      } catch (error) {
        Message.error("网络错误");
        return;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        Message.error(data.InnerData || resp.statusText);
        return;
      }

      const payload = data.InnerData;
      if (payload.Error) {
        this.handleRespError(payload.Error);
        return;
      }

      this._payhandle = payload;

      let payData;
      try {
        payData = await this.getPayData(payload);
      } catch (error) {
        Message.error(error.message);
        return;
      }

      service
        .choosePay(payData, {
          method: this.payMethod
        })
        .then(async success => {
          this.resetPayResultState();

          if (success) {
            Message.info("正在请求支付结果...", { timeout: 0 });
            let confirmed;
            try {
              confirmed = await retry(async () => {
                const r = await this.queryPayResult(payload);
                if (!r) {
                  throw new Error("retry");
                }
                return r;
              }, 2);
            } catch {
              confirmed = false;
            }

            if (confirmed) {
              Message.hide();
              this.getData();
            } else {
              Message.error("由于支付人数较多，请稍后再查看支付结果");
            }
          } else {
            Message.error("支付失败");
          }
        });
      this._showPayResultPopHandle = setTimeout(() => {
        this.showPayResultPop = true;
      }, 2000);
    },
    async getPayData({ OrderCode, PayOrderId }) {
      let resp;
      try {
        resp = await fectxAlt.get(`/pay/${PayOrderId}/${OrderCode}/unified`);
      } catch (error) {
        throw new Error("网络错误");
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        throw new Error(data.InnerData || resp.statusText);
      }

      return data.InnerData.PayData;
    },
    async doQueryPayResult() {
      dev(() => {
        console.log("doQueryPayResult");
      });

      if (!this._payhandle) {
        return;
      }

      const confirmed = await this.queryPayResult(this._payhandle);
      if (confirmed) {
        this.resetPayResultState();
        this.getData();
        // 成功 刷新页面
        // setTimeout(() => {
        //   window.location.reload(true);
        // }, 1000);
      } else if (!this.showPayResultPop && this.queryPayResultTime <= 0) {
        this.resetPayResultState();
        Message.error("支付失败");
      }
    },
    async queryPayResult({ OrderCode, PayOrderId }) {
      let resp;
      try {
        resp = await fectxAlt.get(
          `/pay/${PayOrderId}/${OrderCode}/unified/result`
        );
      } catch (error) {
        return false;
      }
      const data = resp.data;
      // eslint-disable-next-line eqeqeq
      if (data.ResultCode != "200") {
        return false;
      }

      return data.InnerData.Result === true;
    },
    async getData() {
      this.getInfo();
    },
    resetPayResultState() {
      clearTimeout(this._showPayResultPopHandle);
      this.showPayResultPop = false;
      setTimeout(() => {
        this.queryPayResultTime = 5000;
      }, 0);
    }
  }
};
</script>

<style lang="scss">
// ！为了使用 rem 单位每个vue组件都要导入
$page-width: 375;
@import "~style/tool";

.app {
  padding-bottom: rem(51);
}

.main {
  position: relative;
}

.ruleToggle {
  position: absolute;
  top: rem(38);
  right: rem(33);
  font-size: rem(11);
  color: #edcfb7;
  z-index: 1;

  img {
    position: relative;
    top: rem(1);
    margin-left: rem(1);
    width: rem(6);
    height: rem(10);
  }
}

.login {
  position: relative;
  height: rem(219);
  background-color: linear-gradient(
    314deg,
    rgba(85, 69, 56, 1) 0%,
    rgba(104, 89, 81, 1) 100%
  );
  // background-image: url("./assets/login-bg.png");
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .btn {
    position: absolute;
    top: rem(142);
    right: rem(34);
    padding: 0;
    width: rem(126);
    height: rem(32);
    line-height: rem(32);
    background: linear-gradient(
      90deg,
      rgba(248, 120, 116, 1) 0%,
      rgba(200, 43, 43, 1) 100%
    );
    border-radius: rem(16);
    font-size: rem(14);
    font-weight: bold;
    color: rgba(255, 239, 223, 1);
  }
}

.buy {
  height: rem(278);
  background-color: linear-gradient(
    314deg,
    rgba(85, 69, 56, 1) 0%,
    rgba(104, 89, 81, 1) 100%
  );
  // background-image: url("./assets/local-buy-bg.png") !important;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .btn {
    position: absolute;
    top: rem(123);
    left: 0;
    right: 0;
    padding: 0;
    margin-left: auto;
    margin-right: auto;
    width: rem(210);
    height: rem(38);
    background: url("./assets/btn-bg.png") center / 100% 100% no-repeat;
    border-radius: rem(16);
    font-size: rem(14);
    font-weight: bold;
    color: rgba(255, 239, 223, 1);
    display: flex;
    padding-left: rem(20);
    padding-right: rem(24);
    justify-content: space-between;
    align-items: center;
  }
  .btn-1{
    top: rem(147);
  }
  .btn-2{
    top: rem(123);
  }
  .promptPrice {
    font-size: rem(19);
    font-weight: bold;
    color: rgba(216, 69, 68, 1);
    .priceSymbol {
      font-size: rem(14);
    }
  }
  .salePrice {
    position: relative;
    top: rem(-1);
    font-size: rem(14);
    color: rgba(177, 126, 72, 1);
    text-decoration: line-through;
  }
  .ruleToggle-1{
    top: rem(62);
  }
  .text1 {
    font-size: rem(15);
    font-weight: bold;
    color: rgba(255, 247, 240, 1);
  }
}

.card {
  position: relative;
  padding: rem(18) rem(16);

  .ruleToggle {
    color: #c39d77;
  }

  .text1 {
    line-height: 1;
    font-size: rem(16);
    color: rgba(205, 159, 119, 1);
  }

  .text2 {
    margin-top: rem(27);
    img {
      position: relative;
      top: rem(2);
      margin-right: rem(2);
      width: rem(12);
      height: rem(12);
    }

    font-size: 12px;
    color: rgba(205, 159, 119, 1);
  }

  .text-saved {
    margin-top: rem(20);
    font-size: rem(12);
    color: rgba(205, 159, 119, 1);

    img {
      position: relative;
      top: rem(1);
      width: rem(12);
      height: rem(12);
      margin-right: rem(3);
    }
  }
}
.card-content {
  position: relative;
  // background-image: url("./assets/card-bg.png");
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  text-align: center;
  height: rem(195);
  padding-top: rem(55);
}
.card-widget {
  position: absolute;
  top: rem(13);
  left: rem(-2);
  width: rem(159);
  height: rem(25);
}
.card-status {
  margin-top: rem(20);
  padding: 0 rem(38);
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-statusItem {
  width: 50%;
  line-height: 1;
  .text {
    font-size: rem(13);
    color: rgba(102, 102, 102, 1);
  }
  .num {
    margin-top: rem(9);
    font-size: rem(22);
    color: rgba(201, 80, 82, 1);
  }
}
.card-statusItem.yiling {
  .num {
    color: rgba(51, 51, 51, 1);
  }
}
.card-statusItem.shengyu {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: rem(2);
    left: 0;
    height: rem(44);
    width: rem(1);
    background: #ecd4bd;
    opacity: 0.5;
  }
}

.card.is-over {
  .text-saved {
    margin-top: rem(10);
  }

  .card-content {
    // background-image: url("./assets/card-bg-big.png");
    height: rem(241);
  }

  .btn {
    padding: 0;
    margin-top: rem(27);
    width: rem(195);
    height: rem(32);
    line-height: rem(32);
    background: linear-gradient(
      90deg,
      rgba(248, 120, 116, 1) 0%,
      rgba(200, 43, 43, 1) 100%
    );

    border-radius: rem(16);
    font-size: rem(14);
    color: rgba(255, 255, 255, 1);
  }
}

.goods {
  padding-top: rem(17);
}

.goods-title {
  text-align: center;
  font-size: rem(21);
  font-weight: bold;
  color: rgba(94, 91, 91, 1);
  line-height: rem(27);
}

.goods-titleSubText {
  margin-top: rem(5);
  text-align: center;
  font-size: rem(13);
  color: rgba(183, 150, 117, 1);
}

.goodsList {
  margin-top: rem(17);
  margin-left: rem(15);
  margin-right: rem(15);
}
.goodsList-itemRow {
  display: flex;
}
.goodsList-item {
  padding: 0 rem(5);
  flex: 0 0 33.33%;
  width: 33.33%;
  max-width: 33.33%;
}

.footer {
  position: fixed;
  display: none;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(229, 201, 147, 1);
  height: rem(51);
  line-height: 1;
  background: rgba(254, 255, 255, 1);
  align-items: center;

  .footer-left {
    padding: 0 rem(10);
    flex: 0 0 rem(195);
    height: rem(50);
    line-height: rem(50);

    .text1 {
      font-size: rem(17);
      color: #c95052;
      line-height: rem(17);
    }

    .priceSymbol {
      // font-size: rem(15px);
    }
    .promptPrice {
      font-size: rem(20);
      font-weight: bold;
      color: rgba(201, 80, 82, 1);
    }
    .salePrice {
      position: relative;
      top: rem(-1);
      margin-left: rem(3);
      font-size: rem(17);
      color: #666;
      text-decoration: line-through;
    }

    &:after {
      content: "";
      left: rem(8);
      top: rem(-8);
      position: absolute;
      width: rem(72);
      height: rem(21);
      background: url("./assets/xian-shi-you-hui.png") center / 100% 100%
        no-repeat;
    }
  }

  .footer-right {
    text-align: center;
    height: 100%;
    flex: 1 0 auto;
    padding: rem(12) 0 rem(9);
    background: rgba(201, 80, 82, 1);
    color: rgba(255, 255, 255, 1);

    .text1 {
      font-size: rem(14);
      font-weight: bold;
    }
    .text2 {
      margin-top: rem(4);
      font-size: rem(11);
    }
  }
}
.footer.is-active {
  display: flex;
}

.lingquPop.variant.Dialog {
  .text1 {
    margin-top: rem(2);
    font-size: rem(14);
    line-height: rem(22);
    color: rgba(102, 102, 102, 1);
    span {
      color: #d32f3b;
    }
  }

  .item {
    padding: rem(5);
    margin-top: rem(13);
    display: flex;
    border: 0.5px solid #D8D8D8;
  }

  .item_image {
    flex: 0 0 rem(85);
    height: rem(85);
  }

  .item_detail {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: rem(8);
    padding: rem(4) 0;
  }

  .item_name {
    font-size: rem(12);
    line-height: rem(16);
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .item_price {
    margin-top: auto;
    font-size: rem(16);
    line-height: rem(20);
    font-weight: bold;
    color: #333333;
  }
  .text_info{
    margin-top: rem(8);
    font-size:rem(11);
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(201,80,82,1);
    line-height:rem(15);
  }
  .btn {
    margin-top: rem(20);
    padding: 0;
    width: rem(215);
    height: rem(38);
    line-height: rem(38);
    background: rgba(201, 80, 82, 1);
    font-size: rem(14);
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
  }

  .textHint {
    margin: rem(6) auto 0;
    width: rem(215);
    font-size: rem(12);
    color: #C95052;
    line-height: rem(18);
  }
}

.payResultPop.variant.Dialog {
  .Dialog__box {
    width: rem(270);
  }

  .Dialog__body {
    padding: 0;
  }

  .Dialog__title {
    line-height: 1;
    padding: 26px 20px 20px;
    .text1 {
      font-size: rem(14);
      color: rgba(102, 102, 102, 1);
      // font-size: rem(12);
    }

    .text2 {
      margin-top: rem(12);
      font-size: rem(15);
      color: rgba(51, 51, 51, 1);
      line-height: rem(22);
    }
  }

  .Dialog__footer {
    border-top: 1px rgba(233, 233, 233, 1) solid;
    height: rem(46);
    align-items: center;
    justify-content: space-between;
    padding: 0 rem(10);
    .Dialog__btn {
      padding: 0;
      flex: 0 0 rem(122);
      line-height: rem(32);
      height: rem(32);
      background: rgba(218, 218, 218, 1);
      border-radius: rem(1);
    }

    .Dialog__btn.Dialog__btn--ok {
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      background: rgba(201, 80, 82, 1);
    }
  }

  .Dialog__close {
    display: none;
  }
  // &.hideBody .Dialog__body {
  //   display: none;
  // }
}

.payPop.variant.Dialog {
  .Dialog__body {
    width: rem(309);
    padding-left: rem(25);
    padding-right: rem(20);
    padding-bottom: 0;
  }

  .Dialog__title {
    padding-bottom: rem(20);
  }

  .Dialog__content {
    overflow: visible;
    padding-bottom: rem(0);
  }

  .payItem {
    display: flex;
    padding: rem(15) 0;
    align-items: center;

    .icon {
      width: rem(41);
      height: rem(41);
    }

    .text {
      margin-left: rem(16);
      font-size: rem(15);
      color: rgba(51, 51, 51, 1);
    }

    .radio {
      margin-left: auto;
      width: rem(150);
      height: rem(30);
      background: url("./assets/icons/unckecked.png") 100% center / rem(18)
        rem(18) no-repeat;
    }

    input {
      display: none;
    }

    input:checked + .radio {
      background-image: url("./assets/icons/checked.png");
    }
  }

  .payItem + .payItem {
    border-top: 1px solid #e0e0e0;
  }

  .bottom {
    margin-top: rem(10);
    display: flex;
    align-items: center;
    line-height: 1;
    padding: 0 rem(10);
    margin-left: rem(-25);
    margin-right: rem(-20);
    height: rem(50);
    border-top: 1px solid rgba(229, 201, 147, 1);
  }

  .price {
    position: relative;
    height: rem(49);
    line-height: rem(49);

    .priceSymbol {
      // font-size: rem(15px);
    }
    .promptPrice {
      font-size: rem(20);
      font-weight: bold;
      color: rgba(201, 80, 82, 1);
    }
    .salePrice {
      margin-left: rem(3);
      font-size: rem(15);
      color: #666666;
      text-decoration: line-through;
    }

    &:after {
      content: "";
      left: 0;
      top: rem(-8);
      position: absolute;
      width: rem(72);
      height: rem(21);
      background: url("./assets/xian-shi-you-hui.png") center / 100% 100%
        no-repeat;
    }
  }

  .btn {
    margin-left: auto;
    padding: 0;
    width: rem(125);
    height: rem(38);
    line-height: rem(38);
    background: rgba(201, 80, 82, 1);
    font-size: rem(14);
    color: rgba(255, 255, 255, 1);
  }
}

.receviedPop.variant.Dialog {
  .Dialog__box {
    width: rem(275);
  }
  .Dialog__body {
    padding: 0;
    padding-bottom: rem(29);
  }

  .Dialog__title {
    line-height: 1;

    padding-top: 16px;
    padding-bottom: 13px;
    border-bottom: 1px solid rgba(#e2cfbd, 0.5);
    font-size: rem(16);
    color: rgba(215, 67, 66, 1);

    span {
      font-size: rem(19);
      font-weight: bold;
      color: rgba(215, 67, 66, 1);

      position: relative;
      top: rem(1);
    }
  }

  .Dialog__content {
    overflow: visible;
    padding-left: rem(13);
    padding-right: 0;
    padding-bottom: 0;
  }

  .listTitle {
    line-height: 1;
    text-align: left;
    padding-top: 13px;
    padding-bottom: 12px;
    font-size: rem(14);
    color: rgba(51, 51, 51, 1);
  }

  .list {
    margin-right: rem(3);
    padding-right: rem(12);
    height: rem(244);
    overflow: scroll;
  }

  .listItem {
    border-bottom: 1px dashed rgba(#e2cfbd, 0.5);
  }

  .btnContainer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: rem(9) rem(14);
    background: rgba(247, 236, 226, 1);
    border-radius: 0 0 rem(4) rem(4);
  }

  .btn {
    padding: 0;
    width: rem(247px);
    height: rem(32px);
    line-height: rem(32px);
    background: linear-gradient(
      90deg,
      rgba(248, 120, 116, 1) 0%,
      rgba(200, 43, 43, 1) 100%
    );
    border-radius: rem(16);
    font-size: rem(14);
    font-weight: bold;
    color: rgba(255, 247, 240, 1);
  }
}

.is-over.receviedPop.variant.Dialog {
  .Dialog__body {
    padding-bottom: rem(50);
  }

  .list {
    height: rem(240);
  }
}
</style>
